import { MessageCircle, ArrowRight, MapPin } from "lucide-react";
import { waLink, MESSAGES } from "@/data/site";
import { INDUSTRIES } from "@/data/industries";
import { useLang } from "@/i18n";

const Hero = () => {
  const t = useLang().t;
  const mockups = INDUSTRIES.filter((i) => i.demo).slice(0, 3);
  const mockIdx = mockups.map((m) => INDUSTRIES.indexOf(m));
  return (
    <section id="top" data-testid="hero" className="relative overflow-hidden bg-[#FDFBF7]">
      <div className="container-site py-16 sm:py-24 lg:py-28">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <p className="eyebrow" data-testid="hero-eyebrow">{t.hero.eyebrow}</p>
            <h1 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.08] text-[#3E2723]" data-testid="hero-headline">
              {t.hero.titleA} <span className="text-[#A88667]">{t.hero.titleB}</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-[#5D4037]" data-testid="hero-subline">
              {t.hero.sub}
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href="#demos" data-testid="hero-cta-demos" className="btn-primary">
                {t.hero.ctaDemos} <ArrowRight className="h-4 w-4" />
              </a>
              <a href={waLink(MESSAGES.home)} target="_blank" rel="noopener noreferrer" data-testid="hero-cta-whatsapp" className="btn-whatsapp">
                <MessageCircle className="h-4 w-4" /> {t.hero.ctaWhats}
              </a>
            </div>
            <p className="mt-6 flex items-center gap-2 text-sm text-[#8D6E63]">
              <MapPin className="h-4 w-4 text-[#A88667]" /> {t.hero.location}
            </p>
            <p className="mt-1 text-sm font-medium text-[#5D4037]">
              {t.hero.talk}
            </p>
          </div>

          <div className="relative" data-testid="hero-visual">
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-2 overflow-hidden rounded-2xl border border-[#EFEBE4] bg-white shadow-md">
                <div className="flex items-center gap-1.5 border-b border-[#EFEBE4] bg-[#F5F2EB] px-4 py-2.5">
                  <span className="h-2.5 w-2.5 rounded-full bg-[#D7B594]" />
                  <span className="h-2.5 w-2.5 rounded-full bg-[#D7B594]/70" />
                  <span className="h-2.5 w-2.5 rounded-full bg-[#D7B594]/40" />
                  <span className="ml-3 rounded-full bg-white px-3 py-0.5 text-[10px] text-[#8D6E63]">{t.hero.browserUrl}</span>
                </div>
                <img src={mockups[0].image} alt={`${t.industries[mockIdx[0]].name} website demo preview`} className="h-44 sm:h-56 w-full object-cover" />
                <div className="px-4 py-3">
                  <p className="text-xs font-semibold text-[#8D6E63] uppercase tracking-wider">{t.hero.demoTag}</p>
                  <p className="font-heading text-sm font-semibold text-[#3E2723]">{t.industries[mockIdx[0]].name}</p>
                </div>
              </div>
              {mockups.slice(1).map((m, i) => (
                <div key={m.slug} className="overflow-hidden rounded-2xl border border-[#EFEBE4] bg-white shadow-sm">
                  <img src={m.image} alt={`${t.industries[mockIdx[i + 1]].name} website demo preview`} className="h-28 sm:h-36 w-full object-cover" />
                  <div className="px-3 py-2.5">
                    <p className="font-heading text-xs font-semibold text-[#3E2723]">{t.industries[mockIdx[i + 1]].name}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="absolute -bottom-5 -left-4 rounded-2xl border border-[#EFEBE4] bg-white px-4 py-3 shadow-lg">
              <p className="text-[10px] font-semibold uppercase tracking-wider text-[#8D6E63]">{t.hero.startingTag}</p>
              <p className="font-heading text-sm font-bold text-[#3E2723]">{t.hero.starting}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
